import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { Login } from './pages/Login';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { Products } from './pages/Products';
import { Templates } from './pages/Templates';
import { Database } from './pages/Database';
import { Messages } from './pages/Messages';
import { Tasks } from './pages/Tasks';
import { WhatsApp } from './pages/WhatsApp';

const AppContent: React.FC = () => {
  const { user, loading } = useAuth();
  const [currentSection, setCurrentSection] = useState('dashboard');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent mx-auto"></div>
          <p className="mt-4 text-text-secondary">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  const renderSection = () => {
    switch (currentSection) {
      case 'dashboard':
        return <Dashboard />;
      case 'products':
        return <Products />;
      case 'templates':
        return <Templates />;
      case 'database':
        return <Database />;
      case 'messages':
        return <Messages />;
      case 'tasks':
        return <Tasks />;
      case 'whatsapp':
        return <WhatsApp />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <Layout currentSection={currentSection} onNavigate={setCurrentSection}>
      {renderSection()}
    </Layout>
  );
};

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
